import { Controller } from "stimulus"
import domtoimage from 'dom-to-image';

export default class extends Controller {

  download(e) {
    e.preventDefault();
    const node = document.getElementById('jury-capture');
    const indice = node.dataset.indice;
    const year = node.dataset.year;
    gtag('event', 'statistics', {'event_label': `JURY ${indice}`});
    domtoimage.toJpeg(node, { quality: 10 })
    .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = `statistique-jury-${indice}-bts-${year}-ifutur.jpeg`;
        link.href = dataUrl;
        link.click();
    });
  };

  downloadRegion(e) {
    e.preventDefault();
    const node = document.getElementById('region-capture');
    const name = node.dataset.name;
    gtag('event', 'statistics', {'event_label': `Région ${name}`});
    domtoimage.toJpeg(node, { quality: 10 })
    .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = `statistique-region-${name}-bac-${year}-ifutur.jpeg`;
        link.href = dataUrl;
        link.click();
    });
  }
}
